import { render, staticRenderFns } from "./Downtime.vue?vue&type=template&id=906fd832&scoped=true&"
import script from "./Downtime.vue?vue&type=script&lang=js&"
export * from "./Downtime.vue?vue&type=script&lang=js&"
import style0 from "./Downtime.vue?vue&type=style&index=0&id=906fd832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906fd832",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VImg,VList,VListItem,VListItemContent,VSpacer})
